import { render } from "./ChangePassword.vue?vue&type=template&id=ce17e870&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=ce17e870&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ce17e870"

export default script